import styled from 'styled-components'

import { translate } from '../../../../utils/translation'
import { fonts, palette } from '../../../../styles/variables'
import magnifierIcon from '../../../../styles/assets/signupModal/magnifier.svg'
import chartIcon from '../../../../styles/assets/signupModal/chart.svg'
import cogIcon from '../../../../styles/assets/signupModal/cog.svg'
import starIcon from '../../../../styles/assets/signupModal/star.svg'

const argumentInformation = [
  {
    icon: magnifierIcon,
    text: 'sign_up_arguments_one',
  },
  {
    icon: chartIcon,
    text: 'sign_up_arguments_two',
  },
  {
    icon: starIcon,
    text: 'sign_up_arguments_three',
  },
  {
    icon: cogIcon,
    text: 'sign_up_arguments_four',
  },
]

const Wrapper = styled.div(() => ({
  display: 'grid',
}))

const ArgumentWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  fontFamily: fonts.primary,
  fontSize: '14px',
  color: palette.neutral01,
  b: {
    fontFamily: fonts.primaryBook,
    fontWeight: 400,
  },
  lineHeight: '22.4px',
  marginBottom: '24px',
}))

const IconWrapper = styled.div(() => ({
  width: '40px',
  height: '40px',
  borderRadius: '20px',
  border: `1.5px solid ${palette.gray50}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '16px',
}))

const Arguments = () => (
  <Wrapper>
    {argumentInformation.map(({ icon, text }, index) => (
      <ArgumentWrapper key={`${index}-${text}`}>
        <IconWrapper>
          <img src={icon} alt={`Icon of argument list number ${index + 1}`} />
        </IconWrapper>
        <div dangerouslySetInnerHTML={{ __html: translate(text) }} />
      </ArgumentWrapper>
    ))}
  </Wrapper>
)

export default Arguments
